import { render, staticRenderFns } from "./parkingSpot.vue?vue&type=template&id=b7c0f806&scoped=true&"
import script from "./parkingSpot.vue?vue&type=script&lang=js&"
export * from "./parkingSpot.vue?vue&type=script&lang=js&"
import style0 from "./parkingSpot.vue?vue&type=style&index=0&id=b7c0f806&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c0f806",
  null
  
)

export default component.exports